import React from 'react';

interface SpinnerProps {
  className?: string;
}

const Spinner = ({ className = 'center' }: SpinnerProps) => (
  <div className={className} data-testid="spinner">
    <i aria-hidden className="fa fa-spinner fa-spin fa-2x" />
  </div>
);

export default Spinner;
